export const SET_IS_LOADING = "NOTIFICATION/SET_IS_LOADING";
